import { render, staticRenderFns } from "./ExtraClasse.vue?vue&type=template&id=36b65416&"
import script from "./ExtraClasse.vue?vue&type=script&lang=js&"
export * from "./ExtraClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports